import "core-js/modules/es6.symbol.js";
import "core-js/modules/es7.array.includes.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters, mapActions, mapMutations } from 'vuex';
import jwtDecode from 'jwt-decode';
import aa from 'search-insights';
import { NEW_RELIC_SCRIPT } from '@/store/modules/script/types';
import TheFooter from '~/components/specific/TheFooter/TheFooter.vue';
import { ABTASTY_URL, GOOGLE_SITE_VERIFICATION, NORTON_SAFEWEB_SITE_VERIFICATION } from '~/const/3rd';
import { FAST_TIMER } from '~/const/timers';
import parseHash, { refreshTokenIfNecessary } from '~/helpers/auth-helpers';
import { isValidToken } from '~/helpers/connection-helper';
import SEARCH_PROVIDER from '~/helpers/search-data-helpers';
import Notifications from '~/mixins/Notifications';
import ValidateMarketToken from '~/mixins/ValidateMarketToken';
import trackEvent from '~/modules/trackEvent';
import datadome from '~/plugins/datadome';
var MainHeader = () => import('~/components/specific/MainHeader/MainHeader/index.vue');
var MdmLayer = () => import('~/components/atoms/Global/MdmLayer.vue');
var MdmBackToTop = () => import('~/components/atoms/Global/MdmBackToTop.vue');
var SkipLinks = () => import('~/components/molecules/Global/Skiplinks.vue');
var NotificationBanner = () => import('~/components/organisms/Global/NotificationBanner.vue');
export default {
  name: 'Default',
  components: {
    MainHeader,
    TheFooter,
    MdmBackToTop,
    SkipLinks,
    NotificationBanner
  },
  mixins: [Notifications, ValidateMarketToken],
  data() {
    return {
      mdmLayer: null,
      tp: true,
      tcVars: {},
      ready: true,
      hashFirstCat: null,
      routesOnNavModifications: ['market-language-c-alias', 'market-language-p-alias']
    };
  },
  head() {
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [this.newRelicScript, this.tcVarsScript, this.tagCo, this.safariFix, this.searchInsights, this.datadomeJS],
      meta: [{
        hid: 'robots',
        name: 'robots',
        content: 'noodp'
      }, {
        name: 'google-site-verification',
        content: GOOGLE_SITE_VERIFICATION
      }, {
        name: 'norton-safeweb-site-verification',
        content: NORTON_SAFEWEB_SITE_VERIFICATION
      }, {
        name: 'theme-color',
        content: '#3C3C3B'
      }, this.containsQuery],
      link: [...this.preconnectDomains],
      htmlAttrs: {
        lang: this.locale.language
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    user: 'user/me',
    locale: 'i18n/locale',
    tracking: 'sharedEnv/tracking',
    notification: 'notification/notification'
  })), {}, {
    page() {
      return this.handleRouteOnChange(this.$route.name);
    },
    containsQuery() {
      return {};
    },
    preconnectDomains() {
      return [{
        rel: 'preconnect',
        href: 'https://fonts.gstatic.com/',
        crossorigin: true
      }, {
        rel: 'dns-prefetch',
        href: '//fonts.googleapis.com'
      }];
    },
    newRelicScript() {
      var newRelicScript = this.$store.getters[NEW_RELIC_SCRIPT];
      if (newRelicScript === '' || !newRelicScript) {
        return false;
      }
      return {
        innerHTML: newRelicScript,
        body: false,
        head: true
      };
    },
    datadomeJS() {
      return {
        innerHTML: datadome(),
        body: true,
        defer: true
      };
    },
    tcVarsScript() {
      if (process.client || !Object.keys(this.tcVars).length) {
        return false;
      }
      return {
        innerHTML: "window.tc_vars = ".concat(JSON.stringify(this.tcVars), ";"),
        body: true
      };
    },
    searchInsights() {
      if (!process.client && SEARCH_PROVIDER(this) !== 'algolia') {
        return false;
      }
      var {
        applicationId: algoliaApplicationID,
        apiKey: algoliaApiKey
      } = this.$store.state.sharedEnv.payload.algolia;
      var userToken = this.$cookies.get('_ALGOLIA');
      aa('init', {
        appId: algoliaApplicationID,
        apiKey: algoliaApiKey
      });
      if (userToken) {
        aa('setUserToken', userToken);
      }
      return {
        body: true,
        async: true
      };
    },
    tagCo() {
      if (!process.server || this.tp === false) {
        return false;
      }
      return {
        innerHTML: "\n          window.addEventListener(\"load\", function(){\n            var script = document.createElement('script');\n            var s = document.getElementsByTagName('script')[0];\n            script.type = 'text/javascript';\n            script.async = true;\n            window.tc_vars = window.tc_vars || {};\n            window.tc_vars.env_country = window.__NUXT__.state.i18n.currentLocale.market;\n            window.tc_vars.env_language = window.__NUXT__.state.i18n.currentLocale.language;\n            window.tc_vars.env_template = '".concat(this.$route.name, "' == 'market-language-c-alias' ? 'liste produits' :  window.tc_vars.env_template;\n            window.tc_vars.page_url = window.location.pathname;\n            script.onload = function() {\n              window.setTimeout(function() {\n                if(!window.mdm_events) { return; }\n                var tags = window.mdm_events_pending || [];\n                for(var i=0; i<tags.length; i++) {\n                  if(/(^|;\\s?)debugmdm=/.test(document.cookie)) {\n                    console.log('pending tracking', tags[i]);\n                  }\n                  window.mdm_events(").concat(this.tracking.id, ", tags[i].event, tags[i].data.fn || 'track-event', tags[i].data.data);\n                }\n                window.mdm_events_pending = [];\n              }, 0);\n              window.isTcContainerLoadedBefore = true;\n              if(/(^|;\\s?)debugmdm=/.test(document.cookie)) {\n                console.log('tc_container is loaded');\n              }\n            };\n            script.src = '").concat(this.tracking.container, "?").concat(Math.floor(Date.now() / 1000), "';\n            s.parentNode.insertBefore(script, s);\n          }, { passive: true });"),
        body: true
      };
    },
    safariFix() {
      if (!process.server) {
        return false;
      }
      return {
        innerHTML: '!function(){var e=document,t=e.createElement("script");if(!("noModule"in t)&&"onbeforeload"in t){var n=!1;e.addEventListener("beforeload",function(e){if(e.target===t)n=!0;else if(!e.target.hasAttribute("nomodule")||!n)return;e.preventDefault()},!0),t.type="module",t.src=".",e.head.appendChild(t),t.remove()}}();'
      };
    },
    getAlgoliaUserToken() {
      var firstInt = Math.floor(Math.random() * 10000000).toString();
      var secondInt = Math.floor(Math.random() * 10000000).toString();
      var userToken = "anonymous-user-".concat(firstInt, "-").concat(secondInt);
      return userToken;
    }
  }),
  watch: {
    $route(to, from) {
      if (this.notification.message) {
        this.$root.$off('notification-banner');
        this.setNotificationBanner({
          message: '',
          type: ''
        });
      }
    }
  },
  created() {
    if (this.$route.name === 'market-language-cart' || this.$route.name === 'market-language-user' || this.$route.name === 'market-language-user-profile') {
      this.ready = false;
    }
    var algoliaUserToken = Boolean(this.$cookies.get('_ALGOLIA'));
    if (!algoliaUserToken) {
      this.$cookies.set('_ALGOLIA', this.getAlgoliaUserToken);
    }
    if ('nothirdparties' in this.$route.query) {
      this.tp = false;
    }
    if (process.client) {
      var {
        utm_source: utmSource = '',
        utm_medium: utmMedium = '',
        utm_campaign: utmCampaign = '',
        utm_content: utmContent = '',
        gclid = ''
      } = this.$route.query;
      this.$nextTick(() => {
        var mdmSourceContent;
        if (gclid) mdmSourceContent = "gclid=".concat(gclid);else if (utmSource || utmMedium || utmCampaign || utmContent) mdmSourceContent = "utm_source=".concat(utmSource, "|utm_medium=").concat(utmMedium, "|utm_campaign=").concat(utmCampaign, "|utm_content=").concat(utmContent);
        if (mdmSourceContent) {
          this.$cookies.set('MDM_SOURCE', mdmSourceContent, {
            path: '/',
            maxAge: 3600 * 24 * 365
          });
        }
      });
    }
    this.$root.$on('updated-tcvars', this.onUpdateTcVars);
    this.$root.$on('updated-payment-methods', this.onUpdatePaymentMethods);
    this.$root.$on('on-tc-hit-blocker', this.onTcHitBlocker);
    this.$root.$on('user-login-success', this.updateUserAndCart);
    this.$root.$on('user-signup-success', this.fetchUser);
    this.$root.$on('notification-banner', this.notificationBannerMessage);
    this.$root.$on('hashCatFirstLevel', this.getHashFirstCat);
  },
  mounted() {
    var _this = this;
    return _asyncToGenerator(function* () {
      yield refreshTokenIfNecessary({
        app: _this.$store.app,
        store: _this.$store
      });
      var isUserLogged = _this.user && _this.user.id;
      if (isValidToken() && !isUserLogged) {
        _this.loadUser();
      }
      window.history.scrollRestoration = 'auto';
      window.addEventListener('load', _this.onLoad, {
        passive: true
      });
      _this.ready = true;
    })();
  },
  beforeDestroy() {
    window.removeEventListener('load', this.onLoad);
    this.$root.$off('updated-tcvars');
    this.$root.$off('updated-payment-methods');
    this.$root.$off('on-tc-hit-blocker');
    this.$root.$off('generic-tracking');
    this.$root.$off('user-login-success');
    this.$root.$off('user-signup-success');
    this.$root.$off('hashCatFirstLevel');
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions({
    fetchUser: 'user/fetchUser',
    fetchWishlist: 'wishlist/fetchWishlistItems',
    fetchCart: 'cart/fetchCart',
    fetchCartTotalQuantity: 'cart/fetchCartTotalQuantity',
    createCart: 'cart/createCart',
    setSellerIdToCart: 'cart/setSellerIdToCart'
  })), mapMutations({
    setNotificationBanner: 'notification/SET_NOTIFICATION_BANNER'
  })), {}, {
    handleRouteOnChange(route) {
      if (!this.routesOnNavModifications.includes(route)) {
        this.hashFirstCat = null;
      }
    },
    getHashFirstCat(hash) {
      if (this.routesOnNavModifications.includes(this.$route.name)) {
        this.hashFirstCat = hash;
      }
    },
    loadUser() {
      this.fetchUser().then(() => {
        if (this.user) {
          window.mdm_user_intercom_hash = this.user.intercomHashwindow;
          window.mdm_user_intercom_email = this.user.email;
        }
        setTimeout(() => {
          this.$root.$emit('reset-tcvars');
        }, FAST_TIMER);
      }).catch(err => {
        this.$logger.error(err);
      });
    },
    onLoad() {
      if (process.env.NODE_ENV === 'production') {
        this.abTasty();
      }
      this.fetchCartTotalQuantity().catch(err => {
        this.$logger.error(err);
      });
      if (isValidToken()) {
        this.fetchWishlist().catch(err => {
          this.$logger.error(err);
        });
      }
      this.$root.$on('generic-tracking', this.onTracking);
      this.lazyloadComponents();
      if (this.$route.hash) {
        this.connectAs();
      }
    },
    connectAs() {
      var _this2 = this;
      return _asyncToGenerator(function* () {
        // magento return query params behind # instead of ?
        var {
          drc_token: token,
          drc_redirect: connectAs
        } = parseHash(_this2.$route.hash.slice(1));
        if (connectAs) {
          var {
            seller_id: sellerId
          } = jwtDecode(token);
          localStorage.setItem('MDM_ACCESS_TOKEN', token);
          if (sellerId) {
            localStorage.setItem('MDM_CONNECT_AS', connectAs);
          }
          var cartToken = yield _this2.createCart();
          yield _this2.bindSellerIdToCart({
            cartToken,
            sellerId
          });
          window.location.href = _this2.$route.path;
        }
      })();
    },
    bindSellerIdToCart() {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator(function* () {
        var sellerId = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : null;
        if (!sellerId) return;
        localStorage.setItem('MDM_CONNECT_AS', true);
        yield _this3.setSellerIdToCart(sellerId);
      })();
    },
    updateUserAndCart() {
      this.fetchUser();
      this.updateCart();
    },
    updateCart() {
      this.fetchCart().catch(err => {
        this.$logger.error(err);
      });
    },
    onUpdateTcVars(tcVars) {
      this.tcVars = tcVars;
      if (process.client && Object.keys(this.tcVars).length) {
        if (this.$cookies.get('debugmdm')) {
          console.log('inject Tcvars', _objectSpread({}, this.tcVars));
        }
        window.tc_vars = _objectSpread({}, this.tcVars);
        if (window.tC) {
          window.tC.container.reload();
          window.tC.event.reload();
          if (this.$cookies.get('debugmdm')) {
            console.log('container.reload() and event.reload()');
          }
        }
      }
    },
    onUpdatePaymentMethods(paymentMethods) {
      window.tc_vars = _objectSpread(_objectSpread({}, window.tc_vars), {}, {
        paymentMethods
      });
    },
    onTcHitBlocker(tcVars) {
      this.tcVars = tcVars;
      window.tc_vars = _objectSpread({}, this.tcVars);
      if (this.$cookies.get('debugmdm')) {
        console.log('onTcHitBlocker:', _objectSpread({}, window.tc_vars));
      }
    },
    onTracking(el, payload) {
      trackEvent({
        el,
        payload,
        id: this.tracking.id,
        isCookieDebug: this.$nuxt.$cookies.get('debugmdm')
      });
    },
    abTasty() {
      if (this.tp === false) {
        return;
      }
      this.asyncScript(ABTASTY_URL).catch(err => {
        this.$logger.error('ABTASTY FAILED', err);
      });
    },
    notificationBannerMessage(_ref) {
      var {
        message,
        type
      } = _ref;
      this.setNotificationBanner({
        message,
        type
      });
    },
    lazyloadComponents() {
      this.mdmLayer = MdmLayer;
    }
  })
};